import { render, staticRenderFns } from "./ProductTypeVariantDialog.vue?vue&type=template&id=1953654b&scoped=true"
import script from "./ProductTypeVariantDialog.vue?vue&type=script&lang=js"
export * from "./ProductTypeVariantDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductTypeVariantDialog.vue?vue&type=style&index=0&id=1953654b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1953654b",
  null
  
)

export default component.exports